<template>
    <div id="editar-contrato-directorio">
    <v-form v-model="formularioValido" ref="editarDirectorio">
        <v-card flat>
            <v-card-title class="secondary--text mb-4">
            Editar persona del directorio
            <v-spacer></v-spacer>
            <v-btn icon @click="cerrar">
                <v-icon class="secondary--text" large>highlight_off</v-icon>
            </v-btn>
            </v-card-title>
            <v-card-subtitle>
            </v-card-subtitle>
            <v-card-text>
              <v-row>
                <v-col>
                  <custom-text-field
                  cols="12"
                  class=""
                  v-model="directorio.nombre"
                  label="Nombre"
                  :rules="[mixReglas.requerido]"
                  >
                  </custom-text-field>
                  <custom-text-field
                  cols="12"
                  class=""
                  v-model="directorio.puesto"
                  label="Puesto"
                  :rules="[mixReglas.requerido]"
                  >
                   </custom-text-field>
                  <custom-text-field
                  cols="12"
                  class=""
                  v-model="directorio.celular"
                  label="Celular"
                  :rules="[mixReglas.celular]"
                  >
                   </custom-text-field>
                  <custom-text-field
                  cols="12"
                  class=""
                  v-model="directorio.correoElectronico"
                  label="Correo Electrónico"
                  :rules="[mixReglas.email]"
                  >
                  </custom-text-field>
                  <custom-select
                  v-model="directorio.tipo"
                  label="Tipo"
                  :items="tipoLista"
                  item-text="nombre"
                  item-value="tipo"
                  return-value="tipo"
                  :rules="[mixReglas.requerido]"
                  >
                  </custom-select>
                </v-col>
              </v-row>
            </v-card-text>
            <v-divider class="bkground" />
            <v-card-actions>
                <v-spacer></v-spacer>
                <custom-button
                    @click="cerrar"
                    tipo="formCancelar"
                    label="Cancelar"
                    class="mr-3">
                </custom-button>
                <custom-button
                    @click="guardar"
                    tipo="formAceptar"
                    label="Guardar"
                    :disabled="!formularioValido ||
                    enviandoFormulario "
                    :loading="enviandoFormulario"
                    >
                </custom-button>
            </v-card-actions>
        </v-card>
    </v-form>

    </div>
</template>
<script>
import CustomButton from '@/components/buttons/Button.vue';
import CustomTextField from '@/components/inputs/TextField.vue';
import CustomSelect from '@/components/inputs/Select.vue';
import mixDirectorios from './mixDirectorios';

export default {
  name: 'EditarContratoDirectorio',
  mixins: [mixDirectorios],
  props: {
    directorioEditar: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      formularioValido: false,
      enviandoFormulario: false,
      tipoLista: [
        {
          tipo: 1,
          nombre: 'DEPENDENCIA',
        },
        {
          tipo: 2,
          nombre: 'CONTRATISTA',
        },
        {
          tipo: 3,
          nombre: 'SUPERVISION EXTERNA',
        },
        {
          tipo: 4,
          nombre: 'OTROS',
        },
      ],
      directorio: {
        tipo: this.directorioEditar.tipo,
        nombre: this.directorioEditar.nombre,
        puesto: this.directorioEditar.puesto,
        celular: this.directorioEditar.celular,
        correoElectronico: this.directorioEditar.correoElectronico,
      },
    };
  },
  components: {
    CustomButton,
    CustomTextField,
    CustomSelect,
  },
  methods: {
    limpiarFormulario() {
      this.$refs.editarDirectorio.reset();
    },
    cerrar() {
      this.limpiarFormulario();
      this.$emit('cerrar');
    },
    async guardar() {
      await this.mixEditarDirectorio();
    },
  },
};
</script>
